<template>
    <div style="height: 100%;">
        <el-row :gutter="20" class="container">
                <el-col :span="24" :xs="24" class="container" style="flex-direction: column;border-width: 0;padding-top: 25px;">
                    <!-- 搜索区 -->
                    <el-form :model="queryParams.param" ref="queryForm" :inline="true" label-position="right" v-show="showSearch" label-width="110px">
                                <!-- 脚手架名称 -->
                                <el-form-item :label="columnInfo.name.label" prop="name">
                                        <el-input v-model="queryParams.param.name" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                </el-form-item>
                                <!-- 脚手架编码 -->
                                <el-form-item :label="columnInfo.code.label" prop="code">
                                        <el-input v-model="queryParams.param.code" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                </el-form-item>
                                <!-- 版本号 -->
                                <el-form-item :label="columnInfo.version.label" prop="version">
                                        <el-input v-model="queryParams.param.version" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                </el-form-item>
                                 <!-- 描述 -->
                                 <el-form-item :label="columnInfo.description.label" prop="description">
                                        <el-input v-model="queryParams.param.description" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                 </el-form-item>
                                 <!-- 状态 -->
                                 <el-form-item :label="columnInfo.state.label" prop="state">
                                        <enum-dict-select v-model="queryParams.param.state" module-name="data" dict-code="state" placeholder="请选择" size="small" clearable/>
                                 </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="clickSearch">搜索</el-button>
                            <el-button icon="el-icon-refresh" size="small" @click="clickReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <!-- 功能区 -->
                    <el-row :gutter="10" style="margin-bottom:13px;margin-right: 1px">
                        <el-col :span="1.5">
                            <el-button
                                    type="primary"
                                    plain
                                    icon="el-icon-plus"
                                    size="small"
                                    @click="clickAdd"
                                    v-permissionDisabled="'data:scaffold:create'"
                            >新增</el-button>
                        </el-col>
                        <el-col :span="1.5">
                            <el-button
                                    type="success"
                                    plain
                                    icon="el-icon-magic-stick"
                                    size="small"
                                    @click="wizardVisible = true"
                                    v-permissionDisabled="'data:scaffold:create'"
                            >AI创建</el-button>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-import-plus title="脚手架定义表" module-name="data" table-name="scaffold" :permission-code="'data:scaffold:import'"></excel-import-plus>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-export-plus file-name="脚手架定义表" module-name="data" table-name="scaffold" :select-list="selectList" :permission-code="'data:scaffold:export'"></excel-export-plus>
                        </el-col>
                        <right-toolbar-plus :showSearch.sync="showSearch" @queryTable="handleTableSearch"
                                            :columnInfo="columnInfo" @redoTableLayout="redoTableLayout"></right-toolbar-plus>
                    </el-row>
                    <!-- 表格区 -->
                    <div class="main">
                        <div class="table">
                            <el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                                      @selection-change="handleSelectionChange" height="100%" :header-cell-style="{background:'#ECF5FF'}">
                                <el-table-column align="center" type="selection" width="55"/>
                                        <!-- 脚手架名称 -->
                                        <af-table-column align="center" prop="name" :label="columnInfo.name.label" v-if="columnInfo.name.visible">
                                        </af-table-column>
                                        <!-- 脚手架编码 -->
                                        <af-table-column align="center" prop="code" :label="columnInfo.code.label" v-if="columnInfo.code.visible">
                                        </af-table-column>
                                        <!-- 版本号 -->
                                        <af-table-column align="center" prop="version" :label="columnInfo.version.label" v-if="columnInfo.version.visible">
                                        </af-table-column>
                                        <!-- 描述 -->
                                        <af-table-column align="center" prop="description" :label="columnInfo.description.label" v-if="columnInfo.description.visible">
                                        </af-table-column>
                                        <!-- 关联模板包ID -->
                                        <af-table-column align="center" prop="templatePackageId" :label="columnInfo.templatePackageId.label" v-if="columnInfo.templatePackageId.visible">
                                            <template v-slot="scope">
                                                <span>{{ getPackageName(scope.row.templatePackageId) }}</span>
                                            </template>
                                        </af-table-column>
                                        <!-- 状态 -->
                                        <af-table-column align="center" prop="state" :label="columnInfo.state.label" v-if="columnInfo.state.visible">
                                             <template v-slot="scope">
                                                   <enum-dict-label v-model="scope.row.state" dict-code="state" module-name="data" show-tag></enum-dict-label>
                                             </template>
                                        </af-table-column>
                                <!-- 操作列 -->
                                <el-table-column align="center" label="操作" width="320" fixed="right">
                                    <template v-slot="scope">
                                        <el-button @click="clickEdit(scope.row)" type="primary" size="mini" v-permissionDisabled="'data:scaffold:update'">编辑</el-button>
                                        <el-button @click="downloadScaffold(scope.row)" type="success" size="mini" v-permissionDisabled="'data:scaffold:list'">下载</el-button>
                                        <el-button @click="clickDel(scope.row)" type="danger" size="mini" v-permissionDisabled="'data:scaffold:remove'">删除</el-button>
                                        <table-more-button :row="scope.row" :button-props="moreButtonProps" @handleCommand="handleCommand"></table-more-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <!-- 分页区 -->
                    <div style="height: 40px;margin-bottom: 0.1rem;">
                        <pagination-plus :totalCount="totalCount"
                                         :param="queryParams"
                                         :pageSizes="pageSizes"
                                         :selectList="selectList"
                                         module-name="data"
                                         table-name="scaffold"
                                         :del-all-permission-code="'data:scaffold:removes'"
                                         :state-permission-code="'data:scaffold:state'"
                                         @handleTableRefresh="handleTableSearch"/>
                    </div>
                </el-col>
        </el-row>
        <!-- 弹出层组件 -->
        <scaffoldForm/>
        <!-- AI 创建脚手架向导 -->
        <scaffold-create-wizard :visible.sync="wizardVisible" @created="handleTableSearch"/>
    </div>
</template>

<script>
    import scaffoldForm from "./ScaffoldForm"
    import ScaffoldCreateWizard from "./ScaffoldCreateWizard"
    import {mapState, mapMutations, mapActions} from "vuex";
    import {registerStore,unregisterStore} from "@/utils/common";
    import scaffoldDataProvider from "./ScaffoldDataProvider";

    export default {
        components: {
            scaffoldForm,
            ScaffoldCreateWizard
        },
        data() {
            return {
                pageSizes: [10, 20, 40, 80],
                selectList: [],
                showSearch: false,
                exportLoading: false,
                wizardVisible: false,
            }
        },
        computed: {
            ...mapState({
                tableData: state => state.data.scaffold.tableData,
                options: state => state.data.scaffold.options,
                totalCount: state => state.data.scaffold.totalCount,
                columnInfo: state => state.data.scaffold.columnInfo,
                queryParams: state => state.data.scaffold.queryParams,
                dateRange: state => state.data.scaffold.dateRange,
                moreButtonProps: state => state.data.scaffold.moreButtonProps,
            })
        },
        created() {
            registerStore('data','scaffold',scaffoldDataProvider);
            this.handleTableSearch();
            this.getOptionList();
        },
        destroyed() {
            unregisterStore('data','scaffold');
        },
        methods: {
            getPackageName(packageId) {
                if (!packageId || !this.options.templatePackageIdOptions) return '';
                const found = this.options.templatePackageIdOptions.find(item => item.id === packageId);
                return found ? found.packageName : packageId;
            },
            ...mapMutations({
                clickEdit: 'data/scaffold/clickEdit',
                clickAdd: 'data/scaffold/clickAdd',
            }),
            ...mapActions({
                clickDel: 'data/scaffold/handleDel',
                handleTableSearch: 'data/scaffold/handleTableSearch',
                getOptionList: 'data/scaffold/getOptionList',
            }),
            clickReset() {
                for (let key of Object.keys(this.dateRange)) {
                    this.dateRange[key] = []
                }
                this.$refs['queryForm'].resetFields();
                this.handleTableSearch();
            },
            clickSearch() {
                this.queryParams.currPage = 1;
                this.handleTableSearch();
            },
            handleSelectionChange(selectList) {
                this.selectList = selectList;
            },
            redoTableLayout() {
                this.$nextTick(() => {
                    this.$refs.multipleTable.doLayout();
                });
            },
            downloadScaffold(row) {
                if (row.scaffoldFilePath) {
                    window.open('/data/scaffold/download/' + row.id, '_blank');
                } else {
                    this.$message.warning('该脚手架未上传文件');
                }
            },
            handleCommand(command,row) {
            }
        }
    }
</script>

<style lang="less" scoped>
    @import url('~@/assets/style/index.less');

    ::v-deep .el-form-item {
        margin-bottom: 18px;
    }
</style>
